// Query keys for module-related queries
export const moduleQueryKeys = {
  all: ['modules'] as const,
  lists: () => [...moduleQueryKeys.all, 'list'] as const,
  list: (filters?: string) => [...moduleQueryKeys.lists(), { filters }] as const,
  details: () => [...moduleQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...moduleQueryKeys.details(), id] as const,
};

// Query keys for package-module relationships
export const packageModuleQueryKeys = {
  all: ['package-modules'] as const,
  lists: () => [...packageModuleQueryKeys.all, 'list'] as const,
  list: (packageId: string) => [...packageModuleQueryKeys.lists(), packageId] as const,
};

// Mutation keys (optional, useful for useMutationState)
export const packageModuleMutationKeys = {
  add: ['package-modules', 'add'] as const,
  remove: ['package-modules', 'remove'] as const,
};
